import { kmToMiles } from '../../utils/units';
import { isStrengthHistoryCategory } from './workoutExerciseHistoryCategory';

const roundMaybe = (value, digits = 2) => {
  if (!Number.isFinite(value)) return value;
  const factor = 10 ** digits;
  return Math.round(value * factor) / factor;
};

export const toDisplayCardioDistance = (distanceKm, distanceUnit) => (
  distanceUnit === 'mi' ? kmToMiles(distanceKm) : distanceKm
);

export const getCardioDistanceAxisLabel = distanceUnit => `Distance (${distanceUnit === 'mi' ? 'mi' : 'km'})`;

export const formatCardioDistance = (value, distanceUnit) => (
  `${roundMaybe(value, 2)} ${distanceUnit === 'mi' ? 'mi' : 'km'}`
);

export const shouldProjectWorkoutScore = category => {
  const normalized = String(category || '').trim().toLowerCase();
  if (normalized === 'plyometrics') return false;
  return isStrengthHistoryCategory(normalized) || ['static', 'sport'].includes(normalized);
};
